export const publicRoutes = {
  legacyRhinoClaim: '/legacy-rhino-claim',
} as const
